<div class="card card-stretch h-100 rounded-0 context-menu">
    <div class="card-header p-3 d-flex justify-content-between border-bottom-0">
        <h5 class="card-title mb-0 font-weight-bolder">
            <img src="../../../../assets/common/images/Activities/dashboardDepartment.svg" class="h-20px w-20px rounded mr-2" />  {{'Organization Members' | localize}}
        </h5>
        <div *ngIf="isLoaded && !isTeamDataempty" class="ml-auto cursor-pointer card-toolbar">
            <div class="font-weight-bolder text-primary cursor-pointer" (click)="viewall()">
                {{ 'ViewAll' | localize}}
            </div>
        </div>
    </div>

    <div class="card-body p-3">
        <div *ngIf="isLoaded && isTeamDataempty">

            <div class="card">
                <div class="d-flex justify-content-center">
                    <div class="d-flex flex-column mt-20 p-5">
                        <img src="../../../../assets/common/images/new-dashboard/org-unit-empty-ui.svg" class=" img-fluid" />
                        <h6 class="text-muted mt-4 ml-25">{{'NoDataFounds' | localize}}</h6>
                    </div>
                </div>
            </div>
        </div>


        <div *ngIf="!isLoaded && isTeamDataempty" class="mt-5">
            <div class="col-md-12">
                <div class="card cardbackground h-55px border mb-3">
                    <ngx-shimmer-loading [width]="'100%'" [height]="'50px'"></ngx-shimmer-loading>

                </div>
            </div>

            <div class="col-md-12">
                <div class="card cardbackground h-55px border mb-3">
                    <ngx-shimmer-loading [width]="'100%'" [height]="'50px'"></ngx-shimmer-loading>

                </div>
            </div>

            <div class="col-md-12">
                <div class="card cardbackground h-55px border mb-3">
                    <ngx-shimmer-loading [width]="'100%'" [height]="'50px'"></ngx-shimmer-loading>

                </div>
            </div>

            <div class="col-md-12">
                <div class="card cardbackground h-55px border mb-3">
                    <ngx-shimmer-loading [width]="'100%'" [height]="'50px'"></ngx-shimmer-loading>

                </div>
            </div>
        </div>

        <div class="overflow">
            <div  class="row mt-3 pointerClassOrg" *ngIf="isLoaded && !isTeamDataempty" >
                <div *ngFor=" let teamDetails of teamMembersDetails; let i=index" class="col-md-12">
                    <ul *ngIf="i < 5"  class="detailsdepart_ul bg-hover-gray-100 w-100">
                        <li class="icon_li">
                            <img [src]="teamDetails.userProfileImage" class="border border-light rounded p-1 h-50px w-50px" id="profimgsize" />
                        </li>
                        <li class="content_li">
                            <span class="font-weight-bolder" pTooltip="{{teamDetails.userName}}" [tooltipDisabled]="DisableTooltip(teamDetails.userName, 20)" tooltipPosition="bottom">
                                {{teamDetails.userName | titlecase | slice:0:20}}{{teamDetails.userName.length > 20 ? '...' : '' }}
                            </span>
                            <br />
	                         <small class="text-muted" pTooltip="{{teamDetails.userRole?.toString().replace(',' , ', ')}} | {{teamDetails.userOrganizationName}}" [tooltipDisabled]="DisableTooltip((teamDetails.userRole?.toString().replace(',' , ', ') + ' | ' + teamDetails.userOrganizationName), 20)" tooltipPosition="bottom">
                                {{teamDetails.userRole?.toString().replace(',' , ', ') | slice:0:20}} | {{teamDetails.userOrganizationName | slice:0:20}}
                                {{(teamDetails.userRole?.toString().replace(',' , ', ') + ' | ' + teamDetails.userOrganizationName).length > 20 ? '...' : ''}}
                            </small>
                            <br />
                            <small class="text-muted" pTooltip="{{teamDetails.userEmail}}" [tooltipDisabled]="DisableTooltip((teamDetails.userEmail), 20)" tooltipPosition="bottom">
                                {{ (teamDetails.userEmail && teamDetails.userEmail.length) > 20 ? teamDetails.userEmail.slice(0,20)+ '...' : teamDetails.userEmail }}
                            </small>
                        </li>
                    </ul>
                </div>

            </div>


        </div>
    </div>


</div>
